export default __webpack_public_path__ + "static/media/brave_zone_s3.424574f4.png";